__turbopack_context__.v({
  "active": "crt-screen-module__nc01oq__active",
  "blur": "crt-screen-module__nc01oq__blur",
  "clickPrompt": "crt-screen-module__nc01oq__clickPrompt",
  "controlButton": "crt-screen-module__nc01oq__controlButton",
  "customContent": "crt-screen-module__nc01oq__customContent",
  "flicker": "crt-screen-module__nc01oq__flicker",
  "glitch": "crt-screen-module__nc01oq__glitch",
  "glitch1": "crt-screen-module__nc01oq__glitch1",
  "glitch2": "crt-screen-module__nc01oq__glitch2",
  "jerk": "crt-screen-module__nc01oq__jerk",
  "jerkup": "crt-screen-module__nc01oq__jerkup",
  "key": "crt-screen-module__nc01oq__key",
  "liveButton": "crt-screen-module__nc01oq__liveButton",
  "liveDot": "crt-screen-module__nc01oq__liveDot",
  "menu": "crt-screen-module__nc01oq__menu",
  "off": "crt-screen-module__nc01oq__off",
  "on": "crt-screen-module__nc01oq__on",
  "overlay": "crt-screen-module__nc01oq__overlay",
  "paused": "crt-screen-module__nc01oq__paused",
  "picture": "crt-screen-module__nc01oq__picture",
  "playButton": "crt-screen-module__nc01oq__playButton",
  "promptText": "crt-screen-module__nc01oq__promptText",
  "pulsate": "crt-screen-module__nc01oq__pulsate",
  "scanlines": "crt-screen-module__nc01oq__scanlines",
  "screen": "crt-screen-module__nc01oq__screen",
  "text": "crt-screen-module__nc01oq__text",
  "videoContainer": "crt-screen-module__nc01oq__videoContainer",
  "videoControls": "crt-screen-module__nc01oq__videoControls",
  "videoPlayer": "crt-screen-module__nc01oq__videoPlayer",
});
